import ReactPropTypesSecret from "../../../node_modules/prop-types/lib/ReactPropTypesSecret";

var ANONYMOUS = '<<anonymous>>';

export function PropTypeError(message) {
    this.message = message;
    this.stack = '';
}

export function createChainableTypeChecker(validate) {
    var manualPropTypeCallCache = {};
    var manualPropTypeWarningCount = 0;
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
                // New behavior only for users of `prop-types` package
                var err = new Error(
                    'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
                    'Use `PropTypes.checkPropTypes()` to call them. ' +
                    'Read more at http://fb.me/use-check-prop-types'
                );
                err.name = 'Invariant Violation';
                throw err;
            } else if (typeof console !== 'undefined') {
                // Old behavior for people using React.PropTypes
                var cacheKey = componentName + ':' + propName;
                if (
                    !manualPropTypeCallCache[cacheKey] &&
                    // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3
                ) {
                    /*printWarning(
                        'You are manually calling a React.PropTypes validation ' +
                        'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
                        'and will throw in the standalone `prop-types` package. ' +
                        'You may be seeing this warning due to a third-party PropTypes ' +
                        'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
                    );*/
                    manualPropTypeCallCache[cacheKey] = true;
                    manualPropTypeWarningCount++;
                }
            }
        }
        if (props[propName] == null) {
            if (isRequired) {
                if (props[propName] === null) {
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                }
                return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
            }
            return null;
        } else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}